import "./ResetPassword.css";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import Auth from "../Auth/Auth";
import * as links from "../../../utils/links";
import signin from "../../../assets/images/teste_azul1.png";
import { AuthContext } from "../../../contexts/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

const initialDataSignIn = {
  email: "",
  password: "",
  confirmPassword: "",
};

const initErrorField = {
  email: undefined,
  password: undefined,
};

const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const ForgotPassword = (props) => {
  const { token } = useParams();
  const { setDataUser, loading, notiMessage, setNotiMessage } =
    useContext(AuthContext);
  let navigate = useNavigate();

  useEffect(() => {
    console.log(token)
  }, [])

  const [dataAuth, setDataSingUp] = useState({ ...initialDataSignIn });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [errorField, setErrorField] = useState({ ...initErrorField });
  const [isLoading, setIsLoading] = useState(false);

  const onsubmit = () => {
    let dataErrorField = {};
    if (dataAuth.password.trim() === "") {
      dataErrorField = {
        ...dataErrorField,
        password: "Nova Senha obrigatória",
      };
    } else if (dataAuth.confirmPassword.trim() === "") {
      dataErrorField = {
        ...dataErrorField,
        confirmPassword: "Confirme a nova senha",
      };
    } else if (dataAuth.confirmPassword != dataAuth.password) {
      dataErrorField = {
        ...dataErrorField,
        confirmPassword: "As senhas não são iguais",
      };
    }

    setSuccess(false);
    if (Object.keys(dataErrorField).length === 0) {
      setIsLoading(true);
      setError(null);
      axios
        .post(`${process.env.REACT_APP_SERVIDOR}/reset-password/${token}`, {
          newPassword: dataAuth.password.trim(),
        })
        .then((res) => {
          if (res.status === 200) {
            setNotiMessage({
              type: 'success',
              message: 'Senha alterada com sucesso! Realize o novo Login com sua nova senha'
            })
            setIsLoading(false);
            setSuccess(true);
          } else {
            throw new Error();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          // setNotiMessage({
          //     type: 'error',
          //     message: 'Desculpe aconteceu algum problema, não foi possível inserir o crédito remotamente'
          // })
          if (err.response.status === 500) {
            setError(
              'Usuário já existe, <a target="_blank" href=' +
              links.FORGOTPASSWORD +
              ">esqueceu sua senha<a/>?"
            );
          } else {
            setError(
              "Erro, algo deu errado " + (err.response?.data?.error ?? "")
            );
          }
        });
    } else {
      setErrorField((prev) => {
        return {
          ...prev,
          ...dataErrorField,
        };
      });
    }
  };

  return (
    <>
      <NotificationContainer />
      {isLoading && <LoadingAction />}
      {success ?
        <Auth
          authTitle={"Senha alterada com sucesso!"}
          authDescription={"Realize novamente o login com seu usuário e a nova senha!"}
          authFields={[]}
          authSubmit={"Realizar Login"}
          textImage={"IK Pay systema"}
          authImage={signin}
          onsubmit={() => {
            window.location = '/'
          }}
          forgot_password={false}
          errorMessage={error ?? ""}
          isSignIn={true}
        />
        :
        <Auth
          authTitle={"Nova Senha"}
          authDescription={"Preencha a sua nova senha abaixo"}
          authFields={[
            {
              label: "Nova Senha",
              placeholder: "Digite a nova Senha",
              name: "password",
              value: dataAuth?.password ?? "",
              type: "password",
              setField: (value) => {
                setDataSingUp((prev) => ({
                  ...prev,
                  password: value,
                }));
                setErrorField((prev) => ({
                  ...prev,
                  password: undefined,
                }));
              },
              error: errorField?.password ?? "",
            },
            {
              label: "Confirme a nova Senha",
              placeholder: "Digite a senha",
              name: "confirmPassword",
              value: dataAuth?.confirmPassword ?? "",
              type: "password",
              setField: (value) => {
                setDataSingUp((prev) => ({
                  ...prev,
                  confirmPassword: value,
                }));
                setErrorField((prev) => ({
                  ...prev,
                  confirmPassword: undefined,
                }));
              },
              error: errorField?.confirmPassword ?? "",
            }
          ]}
          forgot_password={false}
          authSubmit={"Trocar Senha"}
          textImage={"IK Pay systema"}
          authImage={signin}
          onsubmit={() => {
            onsubmit();
          }}
          successMessage={success ? "Usuário cadastrado com sucesso!" : ""}
          errorMessage={error ?? ""}
          isSignIn={true}
        />
      }

    </>
  );
};

export default ForgotPassword;
